import { Grid } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import buildStyles from './styles'
import AppContext from '../../context'
import { AmountInfo, VoucherInfo } from '../../../api/types'
import AmountBlock from '../../../components/amount-block/AmountBlock'
import { setAmount } from '../../context/actions'
import { useNavigate } from 'react-router-dom'
import HeaderInfo from '../../../components/header-info/HeaderInfo'
import PayAmountNumpad from '../../../components/popups/pay-amount-numpad/PayAmountNumpad'

const AmountView = () => {
  const [openPopup, setOpenPopup] = useState(false)
  const [ownedAmount, setOwnedAmount] = useState<number>(0)

  const { state, contextDispatch } = useContext(AppContext)

  const styles = buildStyles()
  const navigate = useNavigate()

  const willReceiveVoucher = (amount: number) => {
    if (state && state.vouchers) {
      return (
        state.vouchers.filter(
          (voucher: VoucherInfo) =>
            voucher.minPaymentAmount <= amount &&
            ((voucher.maxPaymentAmount && voucher.maxPaymentAmount >= amount) ||
              !voucher.maxPaymentAmount)
        ).length > 0
      )
    }
  }

  const getMinVoucherValue = () => {
    if (state && state.vouchers && state.vouchers.length > 0) {
      return (
        state.vouchers.reduce(
          (min, p) => (p.minPaymentAmount < min ? p.minPaymentAmount : min),
          state.vouchers[0].minPaymentAmount
        ) / 100
      )
    } else return
  }

  const amountBlocks = []
  for (let i = 1; i < 7; i++) {
    if (i < 6) {
      amountBlocks.push(
        <Grid key={i} item xs={6} sm={6} md={4} className={styles.amountBlock}>
          <AmountBlock
            amount={
              {
                value: `${i * 10}`,
                txt: `${i * 10} zł`,
                isVoucher: !!willReceiveVoucher(i * 1000),
              } as AmountInfo
            }
          />
        </Grid>
      )
    } else if (i === 6) {
      amountBlocks.push(
        <Grid key={i} item xs={6} sm={6} md={4} className={styles.amountBlock}>
          <AmountBlock
            amount={
              {
                value: 'other',
                txt: 'Inna kwota',
                isVoucher: state && state.vouchers && !!state.vouchers.length,
              } as AmountInfo
            }
            setOpenPopup={setOpenPopup}
          />
        </Grid>
      )
    }
  }

  const handleConfirm = () => {
    if (!ownedAmount) return

    const amount: AmountInfo = {
      value: ownedAmount.toString(),
      txt: `${ownedAmount} zł`,
    }

    setAmount(contextDispatch, amount)
    if (
      state.locationConfig &&
      state.selectedOrganization &&
      state.selectedGoal
    ) {
      if (state.rules.length > 0) {
        navigate(
          `/${state.locationConfig.locationCode}/${state.selectedOrganization.id}/${state.selectedGoal.id}/regulamin`
        )
      } else {
        navigate(
          `/${state.locationConfig.locationCode}/${state.selectedOrganization.id}/${state.selectedGoal.id}/potwierdzenie`
        )
      }
    }
  }

  return (
    <>
      {state.selectedOrganization && state.selectedGoal && (
        <HeaderInfo
          title="Wybierz kwotę wsparcia"
          arrowedTitle={state.selectedGoal.title}
          orgName={state.selectedOrganization.name}
          addedSmallPadding={true}
        />
      )}
      <Grid container className={styles.container}>
        {amountBlocks}

        <Grid
          item
          container
          direction="row"
          alignItems="flex-end"
          style={{ paddingTop: '20px' }}
        >
          {/* <Grid item xs={12}>
            <StarIcon className={styles.star} />
            <span className={styles.voucherConditionLabel}>
              Wybrana kwota uprawniania Cię do otrzymania vouchera, który możesz
              odebrać po dokonaniu pomyślnej transakcji.
            </span>
          </Grid> */}

          {/* {!!getMinVoucherValue() && (
            <Grid item xs={12}>
              <StarIcon style={{ color: '#f13838' }} className={styles.star} />
              <span className={styles.voucherConditionLabel}>
                Jeśli kwota donacji przekroczy {getMinVoucherValue()} zł jesteś
                uprawniony do otrzymania vouchera.
              </span>
            </Grid>
          )} */}
        </Grid>
      </Grid>

      {openPopup && (
        <PayAmountNumpad
          isOpen={openPopup}
          amount={ownedAmount}
          setAmount={setOwnedAmount}
          onClose={() => {
            setOpenPopup(false)
            setOwnedAmount(0)
          }}
          onConfirm={handleConfirm}
        />
      )}
    </>
  )
}

export default AmountView
